var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dataBoard" },
    [
      _c(
        "basic-container",
        [
          _c(
            "el-form",
            {
              staticClass: "formInline",
              attrs: { inline: true, model: _vm.formInline },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { margin: "0 160px 0 40px" },
                  attrs: { label: "虚拟事件名称" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.formInline.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInline, "name", $$v)
                      },
                      expression: "formInline.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { padding: "12px 40px" },
                      on: {
                        click: () => {
                          _vm.formInline = { name: "", dash_type: "public" }
                          _vm.handleSearch()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { padding: "12px 40px" },
                      attrs: { type: "primary", loading: _vm.loadingSearch },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "basic-container",
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticStyle: { padding: "12px 40px", "margin-left": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增虚拟事件")]
              ),
            ],
            1
          ),
          _c("avue-crud", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingSearch,
                expression: "loadingSearch",
              },
            ],
            ref: "crud",
            staticClass: "table",
            attrs: {
              option: _vm.option,
              page: _vm.page,
              "table-loading": _vm.loading,
              data: _vm.data,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
            },
            scopedSlots: _vm._u([
              {
                key: "name",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#5b93fc", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#F16A6A" },
                        attrs: { size: "small", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDeleteRow(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("addDialog", { ref: "addDialog", on: { getList: _vm.updateList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }